import {
	View,
	Text,
	Image,
	TouchableOpacity,
	ScrollView,
	SafeAreaView,
} from "react-native";
import React, { useState } from "react";
import { AntDesign } from "@expo/vector-icons";
import { PinguinoNormaleImage } from "../assets";
import { privacyPolicyText } from "../utils/privacyPolicy";

const LoginComponent = ({ promptAsync }) => {
	const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false);
	const [viewingPrivacyPolicy, setViewingPrivacyPolicy] = useState(false);

	if (!viewingPrivacyPolicy) {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 items-center justify-center">
					<View className="flex-row items-center justify-around space-x-4 my-4">
						<View className="flex-column w-1/2">
							<Text className="text-2xl font-extrabold text-white">
								Benvenuto!
							</Text>
						</View>
						<Image
							source={PinguinoNormaleImage}
							// className="w-[90px] h-[85px]"
							className="w-[150px] h-[150px]"
						/>
					</View>
					<Text className="text-white text-lg my-2">
						Accedi per cominciare a risolvere problemi
					</Text>
					<TouchableOpacity
						className="flex-row items-center justify-center mx-4 my-4 space-x-2 px-2 py-4 bg-[#1E272C] border-2 border-[#2A373E] rounded-lg"
						onPress={() => {
							acceptedPrivacyPolicy
								? setAcceptedPrivacyPolicy(false)
								: setAcceptedPrivacyPolicy(true);
						}}
					>
						<View className="h-4 w-4 rounded-full border-2 border-white items-center justify-center">
							{acceptedPrivacyPolicy && (
								<View className="h-2 w-2 rounded-full bg-blue-500"></View>
							)}
						</View>
						<View className="flex-auto items-center justify-center max-w-md">
							<Text className="text-slate-400 text-center">
								Dichiaro di avere compiuto 14 anni e di prestare
								il consenso al trattamento dei miei dati
								personali, avendo preso visione della seguente
							</Text>
							<TouchableOpacity
								onPress={() => {
									setViewingPrivacyPolicy(true);
								}}
							>
								<Text className="text-blue-500 text-center">
									informativa sulla privacy
								</Text>
							</TouchableOpacity>
						</View>
					</TouchableOpacity>
					<TouchableOpacity
						className={`flex-row rounded-lg py-2 px-2 space-x-4 border-2 border-[#2A373E] bg-[#1E272C] shadow-sm ${
							acceptedPrivacyPolicy ? "opacity-100" : "opacity-50"
						}`}
						onPress={() => {
							promptAsync();
						}}
						disabled={!acceptedPrivacyPolicy}
					>
						<AntDesign name="google" size={24} color="white" />
						<Text className="text-white text-lg">
							Accedi con Google
						</Text>
					</TouchableOpacity>
					{/* <FontAwesome.Button
				name="google"
				backgroundColor="#1E272C"
				onPress={() => {
					promptAsync();
				}}
			>
				Accedi con Google
			</FontAwesome.Button> */}
				</View>
			</SafeAreaView>
		);
	}

	return (
		<>
			<ScrollView className="px-2 py-2 my-2 max-h-96 bg-[#1E272C] rounded-lg">
				<Text className="text-white">{privacyPolicyText}</Text>
			</ScrollView>
			<View className="">
				<TouchableOpacity
					className="mb-4 py-2 w-full items-center justify-center bg-[#69bddf] rounded-xl"
					onPress={() => {
						setViewingPrivacyPolicy(false);
					}}
				>
					<Text className="text-white text-lg">Continua</Text>
				</TouchableOpacity>
			</View>
		</>
	);
};

export default LoginComponent;
